import React, { Component } from "react";
import {
    Panel,
    Modal,
    Button,
    ButtonToolbar,
    FormGroup,
    ControlLabel,
    FormControl
}                           from "react-bootstrap";
import axios              from "axios";
  import {
    ToastContainer,
    toast
}                           from "react-toastify";
import                           "react-toastify/dist/ReactToastify.css";
import moment from 'moment'
import CrudComponent        from "./../zynappse-crud";
import PointsBannerSchema           from "./PointsBanner.js";
import FormContainer        from "./FormContainer";
import saveTrail            from '../../utils/saveTrail';

import {
    IS_UNDEFINED,
    IS_EMPTY_STRING,
    IS_VALID,
    RETRIEVE_ALL
}                           from "utils";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class PointsBanner extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;
        
        this.refreshTable = this.refreshTable.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.saveData = this.saveData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.getPointsBannerConfig = this.getPointsBannerConfig.bind(this);
        this.savePointsBannerConfig = this.savePointsBannerConfig.bind(this);
        this.accessible = this.accessible.bind(this);
        this.getNumberConfig = this.getNumberConfig.bind(this);
        this.saveNumberConfig = this.saveNumberConfig.bind(this);
        this.getRelation = this.getRelation.bind(this);
        this.uploadSpecificUserCSVFile = this.uploadSpecificUserCSVFile.bind(this);
    }

    refreshTable () {
        if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
            this.refreshTableReference();
        }
    }

    renderModalButton () {
        let {
            PointsBanner,
            actions
        } = this.props;

        let {
            formType,
            isLoadingAction
        } = PointsBanner;

        let buttons = [];

        let button = (name, callback) => (
            <Button
                bsStyle="primary"
                onClick={() => callback()}
                disabled={isLoadingAction}
            >
                {isLoadingAction ? <span><i className="fa fa-spinner fa-spin" style={{ color: "white" }}></i>&nbsp;</span> : ''}
                {name}
            </Button>
        );

        let buttonClose = (
            <Button
                disabled={isLoadingAction}
                onClick={() => {
                    if (!isLoadingAction) {
                        actions.setValue({
                            showModal: false
                        });
                    }
                }}
            >
                CLOSE
            </Button>
        );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    button("CREATE", this.saveData),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    button("UPDATE", this.saveData),
                    buttonClose
                );
                break;
                break;
            case "DELETE":
                buttons.push(
                    button("DELETE", this.deleteData),
                    buttonClose
                );
                break;
            default:
                break;
        }
        return buttons;
    }

    async saveData () {
        let {
            PointsBanner,
            actions
        } = this.props;

        let {
            selectedData,
            formType,
            formId,

            image,
            browser,
            url,
            sort,
            isEasyPromos,
            promoId,
            visibilityType,
            visibilityStartTime,
            visibilityEndTime,
            campaignStartDate,
            campaignEndDate,

            cardType,
            specificUser,
            blacklistedUser,
            deviceType
        } = PointsBanner;

        const isVisibilityType_timeRage = (
            IS_VALID(visibilityType) &&
            visibilityType.value === "TR"
        );

        const getVisibilityTime = () => {
            let month = moment().month(),
                date = moment().date(),
                year = moment().year();

            if (!IS_VALID(visibilityStartTime)) {
                return "Visibility Start Time is required.";
            } else if (
                !moment(visibilityStartTime, "hh:mm A", true).isValid()
            ) {
                return "Please select a valid Visibility Start Time.";
            } else if (!IS_VALID(visibilityEndTime)) {
                return "Visibility End Time is required.";
            } else if (
                !moment(visibilityEndTime, "hh:mm A", true).isValid()
            ) {
                return "Please select a valid Visibility End Time.";
            } else if (
                moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBefore(moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year))
            ) {
                return "Visibility End Time should be greater Visibility Start Time";
            } else if (
                moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isSame(moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year))
            ) {
                return "Visibility Start Time and Visibility End Time should not be the same.";
            }
            // else if (
            //     moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year)) ||
            //     moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year))
            // ) {
            //     return "Visibility Time should not start/end between 12: 00 AM and 03:59 AM";
            // }

            return false;
        };

        const getVisibilityTime_result = getVisibilityTime();

        if (
            image === null
        ) {
            toast.error("Image is required.");
        } else if (
            IS_VALID(browser) &&
            (
                !IS_VALID(url) ||
                !IS_VALID(url.trim())
            )
        ) {
            toast.error("URL is required.");
        } else if (
            !IS_VALID(sort)
        ) {
            toast.error("Sort is required.");
        } else if (
            isEasyPromos &&
            !IS_VALID(promoId)
        ) {
            toast.error("Promo ID is required.");
        } else if (
            IS_VALID(browser) &&
            isEasyPromos &&
            url.toLowerCase().indexOf(promoId.toLowerCase()) === -1
        ) {
            toast.error("Cannot find Promo Id in URL");
        } else if (
            !IS_VALID(visibilityType)
        ) {
            toast.error("Visibility Type is required.");
        } else if (
            isVisibilityType_timeRage &&
            getVisibilityTime_result
        ) {
            toast.error(getVisibilityTime_result);
        } else if (
            IS_VALID(campaignStartDate) &&
            !moment(campaignStartDate, "MMM DD, YYYY", true).isValid()
        ) {
            toast.error("Please select a valid Campaign Start Date");
        } else if (
            IS_VALID(campaignEndDate) &&
            !moment(campaignEndDate, "MMM DD, YYYY", true).isValid()
        ) {
            toast.error("Please select a valid Campaign End Date");
        } else if (
            IS_VALID(campaignStartDate) &&
            IS_VALID(campaignEndDate) &&
            moment(campaignEndDate, "MMM DD, YYYY", true).isBefore(moment(campaignStartDate, "MMM DD, YYYY", true))
        ) {
            toast.error("Campaign End Date should be greater than Campaign Start Date.");
        } else if (
            IS_VALID(campaignStartDate) &&
            IS_VALID(campaignEndDate) &&
            moment(campaignEndDate, "MMM DD, YYYY", true).isSame(moment(campaignStartDate, "MMM DD, YYYY", true))
        ) {
            toast.error("Campaign Start Date and Campaign End Date should not be the same.");
        } else if (
            (
                !IS_VALID(campaignStartDate) &&
                IS_VALID(campaignEndDate)
            ) ||
            (
                IS_VALID(campaignStartDate) &&
                !IS_VALID(campaignEndDate)
            )
        ) {
            toast.error("Please select a Campaign Start and End Date.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let fd = new FormData();

            fd.append("userId", Parse.User.current().id);
            fd.append("sort", sort);

            if (image.preview) {
                fd.append("image", image);
            } else {
                fd.append("isImageChange", false);
            }
            if (IS_VALID(browser)) {
                fd.append("browser", browser.value);

                fd.append("url", url.trim());

                fd.append("isEasyPromos", isEasyPromos);

                if (isEasyPromos) {
                    fd.append("promoId", promoId.trim());
                }
            }

            if (
                IS_VALID(visibilityType) &&
                IS_VALID(visibilityType.value)
            ) {
                fd.append('visibilityType', visibilityType.value); 
            }

            let month = moment().month(),
                date = moment().date(),
                year = moment().year();

            if (
                IS_VALID(visibilityStartTime) &&
                moment(visibilityStartTime, "hh:mm A", true).isValid()
            ) {
                fd.append('visibilityStartTime', moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year).format());
        
                fd.append('visibilityStartTime_string', moment(visibilityStartTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A"));
            }
        
            if (
                IS_VALID(visibilityEndTime) &&
                moment(visibilityEndTime, "hh:mm A", true).isValid()
            ) {
                fd.append('visibilityEndTime', moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).format());
                
                fd.append('visibilityEndTime_string', moment(visibilityEndTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A"));
            }

            if (
                IS_VALID(campaignStartDate) &&
                IS_VALID(campaignEndDate)
            ) {
                fd.append('campaignStartDate', moment(campaignStartDate, "MMM DD, YYYY", true).startOf("d").format());

                fd.append('campaignEndDate', moment(campaignEndDate, "MMM DD, YYYY", true).endOf("d").format());
            }

            if (IS_VALID(cardType) && Array.isArray(cardType) && specificUser.length === 0) {
                for (let index in cardType) {
                    fd.append(`cardTypeIdArray[${index}]`, cardType[index].value || "");
                }
            }

            if (IS_VALID(specificUser) && Array.isArray(specificUser) && cardType.length === 0) {
                for (let index in specificUser) {
                  fd.append(`specificUserIdArray[${index}]`, specificUser[index].value || "");
                }
            }
            if (IS_VALID(blacklistedUser) && Array.isArray(blacklistedUser)) {
                for (let index in blacklistedUser) {
                  fd.append(`blacklistedUserIdArray[${index}]`, blacklistedUser[index].value || "");
                }
            }

            if (IS_VALID(deviceType)) {
                fd.append(`deviceType`, deviceType.value);
            }

            let httpMethod = "post",
                api_url = `${WEB_PATH}/PointsBanner`;

            if (
                (
                    !IS_EMPTY_STRING(formType) &&
                    formType.toUpperCase() === "UPDATE"
                ) &&
                !IS_EMPTY_STRING(formId)
            ) {
                httpMethod = "put";
                api_url = `${api_url}/${formId}`;
            }

            axios[httpMethod](api_url, fd)
            .then((res) => {
                let {
                    data,
                    changesObject
                } = res.data;

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    changesObject
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    deleteData () {
        let {
            PointsBanner,
            actions
        } = this.props;

        let {
            selectedData
        } = PointsBanner;

        actions.setValue({ isLoadingAction: true });

        selectedData.destroy()
        .then((data) => {
            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();

            saveTrail(
                "DELETE",
                {
                    objectId: selectedData.id,
                    image: selectedData.get("image").url(),
                    browser: selectedData.get("browser") || "",
                    url: selectedData.get("url") || "",
                    sort: selectedData.get("sort") || 0
                }
            );
        })
        .catch((err) => {
            console.log("deleteData error");
            console.log(err);

            actions.setValue({
                isLoadingAction: false,
                showModal: false
            });

            this.refreshTable();
        })
    }

    getPointsBannerConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            isLoadingConfig: true
        });

        let customBlockMessageConfigQuery = new Parse.Query("PointsBannerConfig");

        customBlockMessageConfigQuery
        .equalTo("name", "POINTS")
        .descending("createdAt");

        customBlockMessageConfigQuery.first()
        .then((data) => {
            let stateToUpdate = {
                isLoadingConfig: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.isActive = IS_VALID(data.get("isActive")) ? data.get("isActive") : true;
                stateToUpdate.PointsBannerConfig = data;
            } else {
                stateToUpdate.isActive = true;
            }

            actions.setValue(stateToUpdate);
        })
        .catch((err) => {
            console.log("getPointsBannerConfig error");
            console.log(err);

            actions.setValue({
                isLoadingConfig: false
            });
        });
    }

    savePointsBannerConfig () {
        let {
            PointsBanner,
            actions
        } = this.props;
        
        let {
            isActive,
            PointsBannerConfig
        } = PointsBanner

        actions.setValue({ isSavingConfig: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(PointsBannerConfig)) {
              resolve(PointsBannerConfig);
            } else {
              let query = new Parse.Query("PointsBannerConfig");
      
              query
              .equalTo("name", "POINTS")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((PointsBannerConfig) => {
            if (IS_UNDEFINED(PointsBannerConfig)) {
                PointsBannerConfig = new Parse.Object("PointsBannerConfig");

                PointsBannerConfig.set("name", "POINTS");
            }

            PointsBannerConfig
            .set("isActive", !isActive);

            return PointsBannerConfig.save();
        })
        .then((PointsBannerConfig) => {
            let stateToUpdate = {
                isSavingConfig: false,
                isActive: !isActive,
                showModalConfig: false,
                PointsBannerConfig
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                isActive ? "DEACTIVATE" : "ACTIVATE",
                {
                    isActive: !isActive
                }
            );
        })
        .catch((err) => {
            console.log("savePointsBannerConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }
    
    accessible (actionType) {
		let {
			access
		} = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
					index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
					actions = [];

			if (access[index]) {
				actions = access[index].actions
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
	      return 'none';
	    }
		} else {
			return 'none';
		}
	}

    getNumberConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            delayConfig_isLoading: true
        });

        let numberConfigQuery = new Parse.Query("NumberConfig");

        numberConfigQuery
        .equalTo("name", "POINTS")
        .descending("createdAt");

        numberConfigQuery.first()
        .then((data) => {
            let stateToUpdate = {
                delayConfig_isLoading: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.delayConfig = data;
                stateToUpdate.delayConfig_value = data.get("value") || 0;
            } else {
                stateToUpdate.delayConfig_value = 0;
            }

            actions.setValue(stateToUpdate);
        })
        .catch((err) => {
            console.log("getNumberConfig error");
            console.log(err);

            actions.setValue({
                delayConfig_isLoading: false
            });
        });
    }

    saveNumberConfig () {
        let {
            PointsBanner,
            actions
        } = this.props;
        
        let {
            delayConfig,
            delayConfig_value
        } = PointsBanner

        delayConfig_value = parseInt(delayConfig_value) || 0;

        if (
            delayConfig_value <= 0
        ) {
            return toast.error("Delay should not be zero.");
        }
        
        actions.setValue({ delayConfig_isSaving: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(delayConfig)) {
              resolve(delayConfig);
            } else {
              let query = new Parse.Query("NumberConfig");
      
              query
              .equalTo("name", "POINTS")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((numberConfig) => {
            if (IS_UNDEFINED(numberConfig)) {
                numberConfig = new Parse.Object("NumberConfig");

                numberConfig.set("name", "POINTS");
            }

            numberConfig
            .set("value", delayConfig_value*1000);

            return numberConfig.save();
        })
        .then((numberConfig) => {
            let stateToUpdate = {
                delayConfig_isSaving: false,
                delayConfig_showModal: false,
                delayConfig: numberConfig,
                delayConfig_value: delayConfig_value
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                "UPDATE",
                {
                    Delay: delayConfig_value
                }
            );
        })
        .catch((err) => {
            console.log("saveNumberConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }

    loadOptions (input, cb, className, columnName, sortColumn = columnName) {
        let query,
            objectItem = (item) => {
              let json = {
                label: item.get(columnName),
                value: item.id
              };
    
              if (
                className === "VoucherValidityType" ||
                className === "VoucherType"
              ) {
                json.shortName = item.get("shortName");
              }
    
              return json;
            };
    
        if (className === "MemberDetail") {
          let query1 = new Parse.Query(className),
              query2 = new Parse.Query(className);
    
          query1.matches("memberId", input, "i");
    
          query2.matches("name", input, "i");
    
          query = Parse.Query.or(query1, query2);
    
          query.exists("memberId");
          query.notEqualTo("memberId", "");
    
          query.ascending("name");
    
          objectItem = (item) => {
            return {
              label: `${IS_VALID(item.get("memberId")) ? item.get("memberId") : ""} ${IS_VALID(item.get("name")) ? item.get("name") : ""}`,
              value: item.id
            }
          };
        } else if (className === "User") {
          query = new Parse.Query(Parse.User);
    
          query.equalTo("userType", "MERCHANT");
          query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
          query.ascending(sortColumn);
        } else if (className === "CampaignCategory") {
          query = new Parse.Query(className);
          
          query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
          query.ascending(sortColumn);
    
          objectItem = (item) => {
            let json = {
              label: item.get(columnName),
              value: item.id
            };
    
            // let additionalColumns = [
            //   "descriptions",
            // ];
    
            // for (let column of additionalColumns) {
            //   if (IS_VALID(item.get(column))) {
    
            //     json[column] = item.get(column);
            //   }
            // }
    
            return json;
          };
        } else {
          query = new Parse.Query(className);
    
          query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
          query.ascending(sortColumn);
        }
    
        query.limit(20);
    
    
        query.find()
        .then((data) => {
                return data.map(objectItem);
            }).then((data) => {
                cb(null, {options: data});
            })
        .catch((err) => {
          console.log('Load Select Options error: ', err.message);
        })
    }

    getRelation () {
        let {
          actions,
          PointsBanner
        } = this.props;
    
        let {
          formType,
          selectedData
        } = PointsBanner;
    
        let cardTypeRelationQuery = selectedData.relation("cardType").query(),
            specificUser = selectedData.relation("specificUser").query(),
            blacklistedUser = selectedData.relation("blacklistedUser").query();
    
        cardTypeRelationQuery.ascending("name");
        specificUser.ascending("name");
        blacklistedUser.ascending("name");
    
        return Promise.all([
          cardTypeRelationQuery.find(),
          RETRIEVE_ALL(specificUser),
          RETRIEVE_ALL(blacklistedUser)
        ]);
    }

    uploadSpecificUserCSVFile (csvFile, stateName) {
        let {
          PointsBanner,
          actions
        } = this.props;
    
        let selectUserStateArray = PointsBanner[stateName],
            loadingState = stateName === "blacklistedUser" ? "isUploadingCSVFileBlacklistedUser" : "isUploadingCSVFile";
    
        actions.setValue(
          {
            [loadingState]: true
          }
        );
    
        let fd = new FormData();
    
        fd.append("csvFile", csvFile);
    
        axios.post(
          WEB_PATH + "/MemberDetail/upload",
          fd
        )
        .then((res) => {
          let {
            data
          } = res;
    
          let updatedUserArray = [...selectUserStateArray];
    
          for (let item of data) {
            if (updatedUserArray.map((item) => item.value).indexOf(item.objectId) === -1) {
              updatedUserArray.push({
                label: `${IS_VALID(item.memberId) ? item.memberId : ""} ${IS_VALID(item.name) ? item.name : ""}`,
                value: item.objectId
              });
            }
          }
    
          actions.setValue(
            {
              [loadingState]: false,
              [stateName]: updatedUserArray
            }
          )
        })
        .catch((err) => {
          console.log("uploadSpecificUserCSVFile error: ", err);
    
          actions.setValue(
            {
              [loadingState]: false
            }
          )
        });
    }

    render () {
        let {
            PointsBanner,
            accessjson,
            actions
          } = this.props;
      
          let {
            showModal,
            isLoadingAction,

            selectedData,
            formType,
            formTitle,

            browserOptions,
            visibilityOptions,

            showModalConfig,
            isSavingConfig,
            isLoadingConfig,
            isActive,

            delayConfig_showModal,
            delayConfig_isSaving,
            delayConfig_isLoading,
            delayConfig,
            delayConfig_value
        } = PointsBanner;

        let crudProps = {
            schema: PointsBannerSchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "ascending", column: "sort" }
            ],
            saveTrail: saveTrail,
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customView: (obj) => {
                actions.setValue({
                    showModal: true,
                    formType: "VIEW",
                    formTitle: "VIEW POINTS BANNER",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            customCreate: () => {
                actions.setValue({
                    showModal: true,
                    formType: "CREATE",
                    formTitle: "CREATE POINTS BANNER",
                    formId: "",
                    selectedData: null
                });
            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE POINTS BANNER",
                    formId: obj.id,
                    selectedData: obj
                };
                
                if (IS_VALID(obj.get("image"))) {
                    stateToUpdate.image = { url: obj.get("image").url(), name: obj.get("image").name() };
                }

                if (IS_VALID(obj.get("browser"))) {
                    let index = browserOptions.map(({ value }) => value).indexOf(obj.get("browser"));

                    if (index !== -1) {
                        stateToUpdate.browser = browserOptions[index];
                    }
                }

                if (IS_VALID(obj.get("url"))) {
                    stateToUpdate.url = obj.get("url");
                }

                if (IS_VALID(obj.get("sort"))) {
                    stateToUpdate.sort = obj.get("sort");
                }

                if (IS_VALID(obj.get("isEasyPromos"))) {
                    stateToUpdate.isEasyPromos = obj.get("isEasyPromos");
                }

                if (IS_VALID(obj.get("promoId"))) {
                    stateToUpdate.promoId = obj.get("promoId");
                }

                if (IS_VALID(obj.get("visibilityType"))) {
                    for (const item of visibilityOptions) {
                        if (
                            item.value === obj.get("visibilityType")
                        ) {
                            stateToUpdate.visibilityType = item;
                            break;
                        }
                    }
                }

                if (IS_VALID(obj.get("visibilityTimeConfig"))) {
                    const timeConfig = obj.get("visibilityTimeConfig");

                    let month = moment().month(),
                        date = moment().date(),
                        year = moment().year();

                    if (IS_VALID(timeConfig.start)) {
                        stateToUpdate.visibilityStartTime = moment(timeConfig.start, "hh:mm A", true).month(month).date(date).year(year);
                    }
                
                    if (IS_VALID(timeConfig.end)) {
                        stateToUpdate.visibilityEndTime = moment(timeConfig.end, "hh:mm A", true).month(month).date(date).year(year);
                    }
                }

                if (IS_VALID(obj.get("campaignStartDate"))) {
                    stateToUpdate.campaignStartDate = moment(obj.get("campaignStartDate"));
                }

                if (IS_VALID(obj.get("campaignEndDate"))) {
                    stateToUpdate.campaignEndDate = moment(obj.get("campaignEndDate"));
                }

                if (IS_VALID(obj.get("deviceType"))) {
                    stateToUpdate.deviceType = {
                        label: obj.get("deviceType"),
                        value: obj.get("deviceType")
                    };
                }
                
                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) => {
                actions.setValue({
                    showModal: true,
                    formType: "DELETE",
                    formTitle: "DELETE POINTS BANNER",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            customItems: [
                {
                    columnName: "sort",
                    render: ({value, column, getTableData, object}) => {
                        let renderValue = "";
            
                        if (IS_VALID(object.get("sort"))) {
                            renderValue = object.get("sort");
                        }
            
                        return renderValue;
                    }
                }
            ]
        };

        let formContainerProps = {
            actions,

            selectedData,
            formType,

            visibilityOptions,

            loadOptions: this.loadOptions,
            getRelation: this.getRelation
        };

        let isActivateAccessible = this.accessible("ACTIVATE") === "",
            isDeactivateAccessible = this.accessible("DEACTIVATE") === "",
            isUpdateAccessible = this.accessible("UPDATE") === "";

        return (
            <div>
                <Panel>
                    <Panel.Heading style={{
                        backgroundColor: '#D1282F',
                        color: 'white'
                    }}>
                        <h4 style={{ display: "inline-block" }}>Points Banner</h4>
                        <div style={{ float: "right" }}>
                            <ButtonToolbar>
                            <Button
                                style={(!isUpdateAccessible) ? { cursor: "not-allowed" } : null}
                                disabled={delayConfig_isLoading || !isUpdateAccessible}
                                onClick={() => {

                                    if (
                                       !isUpdateAccessible
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        delayConfig_showModal: true,
                                        delayConfig_value: (delayConfig.get("value") || 0)/1000
                                    });
                                }}
                            >
                                {delayConfig_isLoading ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    `${delayConfig ? (delayConfig.get("value") || 0)/1000 : 0}s`
                                )}
                            </Button>
                            <Button
                                style={(isActive ? !isDeactivateAccessible : !isActivateAccessible) ? { cursor: "not-allowed" } : null}
                                bsStyle={isLoadingConfig ? null : isActive ? "success" : "danger"}
                                disabled={isLoadingConfig || (isActive ? !isDeactivateAccessible : !isActivateAccessible)}
                                onClick={() => {

                                    if (
                                        (isActive ? !isDeactivateAccessible : !isActivateAccessible)
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        showModalConfig: true
                                    });
                                }}
                            >
                                {isLoadingConfig ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    isActive ? "ACTIVE" : "INACTIVE"
                                )}
                            </Button>
                            </ButtonToolbar>
                        </div>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps}/>
                    </Panel.Body>
                </Panel>
                <Modal
                    bsSize={null}
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                     <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={showModalConfig}
                    onHide={() => {
                        if (!isSavingConfig) {
                            actions.setValue({
                                showModalConfig: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>{isActive ? "DEACTIVATE " : "ACTIVATE "} POINTS BANNER</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {`Are you sure you want to ${isActive ? "deactivate" : "activate"} Points Banner?`}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle={isActive ? "danger" : "success"}
                            disabled={isSavingConfig}
                            onClick={() => this.savePointsBannerConfig()}
                        >
                            {isActive ? "DEACTIVATE" : "ACTIVATE"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={delayConfig_showModal}
                    onHide={() => {
                        if (!delayConfig_isSaving) {
                            actions.setValue({
                                delayConfig_showModal: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>POINTS BANNER DELAY</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <FormGroup>
                            <ControlLabel>Delay (seconds)</ControlLabel>
                            <FormControl
                                value={delayConfig_value}
                                onChange={(e) => {
                                    actions.setValue({
                                        delayConfig_value: e.target.value.replace(/[^0-9]/g, "")
                                    })
                                }}
                            />
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle="primary"
                            disabled={delayConfig_isSaving}
                            onClick={() => this.saveNumberConfig()}
                        >
                            SAVE
                        </Button>
                        <Button
                            disabled={delayConfig_isSaving}
                            onClick={() => {
                                if (!delayConfig_isSaving) {
                                    actions.setValue({
                                        delayConfig_showModal: false
                                    });
                                }
                            }}
                        >
                            CLOSE
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }

    componentDidMount () {
        this.getPointsBannerConfig();

        this.getNumberConfig();
    }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
    SET_POINTS_BANNER
}                           from "actions/const";

function mapStateToProps(state) {
	var {
		accessjson,
        PointsBanner
	} = state;
	return {
		accessjson,
        PointsBanner
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (keyValueObj, actioType = SET_POINTS_BANNER) => generics.setValue(actioType, keyValueObj)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PointsBanner);


// WEBPACK FOOTER //
// ./components/PointsBanner/index.js